import { Link } from 'react-router-dom';
import type { LegalDocument } from './legalContent';
import { azaleaPath, SUPPORT_EMAIL, SUPPORT_URL } from './constants';

function renderParagraph(text: string) {
  if (text.startsWith('http://') || text.startsWith('https://')) {
    return (
      <p key={text}>
        <a href={text} rel="noopener noreferrer" target="_blank">
          {text}
        </a>
      </p>
    );
  }

  const emailMatch = text.match(/([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/);
  if (emailMatch) {
    const email = emailMatch[1];
    const [before, after] = text.split(email);
    return (
      <p key={text}>
        {before}
        <a href={`mailto:${email}`}>{email}</a>
        {after}
      </p>
    );
  }

  return <p key={text}>{text}</p>;
}

function LegalRelatedLink({ docId }: { docId: string }) {
  if (docId !== 'privacy' && docId !== 'terms') return null;

  return (
    <p className="azalea-doc-related">
      {docId === 'privacy' ? (
        <>
          See also: <Link to={azaleaPath('terms')}>Terms of Use</Link>
        </>
      ) : (
        <>
          See also: <Link to={azaleaPath('privacy')}>Privacy Policy</Link>
        </>
      )}
    </p>
  );
}

export function AzaleaLegalDoc({ doc }: { doc: LegalDocument }) {
  return (
    <main className="azalea-main azalea-doc">
      <Link to={azaleaPath()} className="azalea-back-link">
        ← Back to Azalea
      </Link>

      <header className="azalea-doc-header">
        <h1>{doc.title}</h1>
        {doc.lastUpdated && (
          <p className="azalea-doc-updated">Last updated: {doc.lastUpdated}</p>
        )}
        <LegalRelatedLink docId={doc.id} />
      </header>

      {doc.sections.map((section, i) => (
        <section key={i} className="azalea-doc-section">
          {section.heading && <h2>{section.heading}</h2>}
          {section.paragraphs?.map(renderParagraph)}
          {section.bullets && (
            <ul>
              {section.bullets.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          )}
        </section>
      ))}

      {doc.id === 'support' && (
        <p style={{ marginTop: 24 }}>
          <a href={SUPPORT_URL} className="azalea-btn-secondary">
            Email {SUPPORT_EMAIL}
          </a>
        </p>
      )}

      {(doc.id === 'privacy' || doc.id === 'terms') && (
        <div className="azalea-doc-related" style={{ marginTop: 32 }}>
          <LegalRelatedLink docId={doc.id} />
        </div>
      )}
    </main>
  );
}
